import { render, staticRenderFns } from "./DefaultSchemaWithUserSelection.vue?vue&type=template&id=ca995f3a&scoped=true&"
import script from "./DefaultSchemaWithUserSelection.vue?vue&type=script&lang=ts&"
export * from "./DefaultSchemaWithUserSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca995f3a",
  null
  
)

export default component.exports